import { HistoryStack } from './history-stack'
import { useHistoryContext } from './HistoryProvider'

/**
 * return the current history stack with all the previous
 * matched routes, this is a readonly object, modifying this
 * will not modify the real history of the browser!
 */
export function useHistory() {
  const historyContext = useHistoryContext()
  const cloned = new HistoryStack(historyContext.historyStack)
  return cloned
}
